import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enUS from './langs/en-US'
import zhCN from './langs/zh-CN'
import jaJP from './langs/ja-JP'
import koKR from './langs/ko-KR'
import ruRU from './langs/ru-RU'
import esES from './langs/es-ES'
import frFR from './langs/fr-FR'
import arSA from './langs/ar-SA'
import store from '../store'

Vue.use(VueI18n)

const messages = {
  'en': enUS,
  'zh': zhCN,
  'ja': jaJP,
  'ko': koKR,
  'ru': ruRU,
  'es': esES,
  'fr': frFR,
  'ar': arSA
}

// 获取浏览器语言设置
const getBrowserLang = () => {
  try {
    // 检查 navigator 是否存在
    if (typeof navigator === 'undefined') {
      return 'en'
    }
    
    // 安全获取浏览器语言
    const browserLang = navigator.language || navigator.userLanguage || ''
    
    // 检查 browserLang 是否有效
    if (!browserLang || typeof browserLang !== 'string') {
      return 'en'
    }
    
    const langCode = browserLang.toLowerCase()
    const language = langCode.split('-')[0]
    
    // 检查 language 是否有效且存在于 messages 中
    if (language && language.length > 0 && messages.hasOwnProperty(language)) {
      // 更新vuex中的语言状态
      store.dispatch('setLanguage', language)
      localStorage.setItem('language', language)
      return language
    }
    
    // 如果不支持，返回相近的语言或默认语言
    if (langCode.startsWith('en')) {
      store.dispatch('setLanguage', 'en')
      localStorage.setItem('language', 'en')
      return 'en'
    }
    
    // 默认返回英文，并更新vuex
    store.dispatch('setLanguage', 'en')
    localStorage.setItem('language', 'en')
    return 'en'
  } catch (error) {
    console.warn('获取浏览器语言失败，使用默认语言:', error)
    // 发生错误时返回默认语言
    store.dispatch('setLanguage', 'en')
    localStorage.setItem('language', 'en')
    return 'en'
  }
}

// 获取初始语言设置
const getInitialLocale = () => {
  const savedLanguage = localStorage.getItem('language')
  if (savedLanguage && messages.hasOwnProperty(savedLanguage)) {
    return savedLanguage
  }
  return getBrowserLang()
}

const i18n = new VueI18n({
  locale: getInitialLocale(),
  fallbackLocale: 'en',
  messages,
  silentTranslationWarn: true
})

export default i18n 